import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetInvestingActivitiesNetCashCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [investingActivitiesNetCashFiled] = observedFields.investingActivitiesNetCash.setCalculatedValueFieldNames;

  const getInvestingActivitiesNetCashCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;
        const [purchasePPE, investingActivitiesTableValues] = content;
        const investingActivitiesNetCash = summarizeSubtractPeriodValues(
          [...investingActivitiesTableValues, purchasePPE],
          PERIODS_OPERATION_TYPES.ADD,
        );

        setValue(investingActivitiesNetCashFiled, investingActivitiesNetCash);
      }, 500),

    [],
  );

  return getInvestingActivitiesNetCashCalculationHandler;
};
